import { useState, useEffect } from 'react';
import Team from '../schemas/Team';
import Card from 'react-bootstrap/Card';
import TeamModal from './TeamModal';

function TeamCard({ team }: { team: Team }) {
    const [currentTeamName, setCurrentTeamName] = useState("");
    const [show, setShow] = useState(false);

    useEffect(() => {
        setCurrentTeamName(team.teamName[(team.teamName).length - 1]);
    }, []);

    const handleClick = (e: any) => {
        const clickedImg = e.target as HTMLElement;
        if (!(clickedImg instanceof HTMLImageElement)) return;

        const src = clickedImg.getAttribute('src') || '';
        const file = src.split('/').pop() || ''; 
        const baseName = file.replace(/.[^/.]+$/, ''); 
        const targets = ['por', 'phi'];
        if (targets.some(t => baseName.includes(t))) {
            setShow(false);
            console.log("אתר זה נועד רק לחברי הליגה שמפגינים רוח חברית וספורטיבית.")
        } else {
            setShow(true);
        }
    }

    return (
        <>
            <Card
                className='mb-3'
                onClick={(e) => handleClick(e)}
                style={{ cursor: 'pointer' }}
            >
                <Card.Img variant="top" src={team.teamLogo} />
                <Card.Body>
                    <Card.Text className='fw-semibold'>
                        {currentTeamName}
                    </Card.Text>
                </Card.Body>
            </Card>
            <TeamModal
                show={show}
                setShow={setShow}
                fullscreen={true}
                team={team}
            />
        </>
    )
}

export default TeamCard;